document.addEventListener('DOMContentLoaded', () => {
  const explanationDialog = document.querySelector<HTMLDialogElement>('.js-explanation');
  const selectedTextJs = document.querySelector<HTMLElement>('.js-explanation-selected-text');
  const explanationTextJs = document.querySelector<HTMLElement>('.js-explanation-explanation');
  const closeButton = explanationDialog?.querySelector<HTMLButtonElement>('.close-button');

  const toggleExplanation = (span: HTMLSpanElement): void => {
    if (!explanationDialog) return;

    if (explanationDialog.open) {
      explanationDialog.close();
    } else {
      const explanationText = span.getAttribute('data-explanation') || '';
      const selectedText = span.getAttribute('data-selectedText') || 'No text selected';

      if (selectedTextJs) {
        selectedTextJs.innerText = selectedText;
      }
      if (explanationTextJs) {
        explanationTextJs.innerText = explanationText;
      }

      explanationDialog.showModal();
    }
  };

  const closeExplanation = (): void => {
    explanationDialog?.close();
  };

  if (explanationDialog && closeButton) {
    const explanationSpans = document.querySelectorAll<HTMLSpanElement>('.explanation');

    explanationSpans.forEach((span) => {
      // Click event
      span.addEventListener('click', () => toggleExplanation(span));

      // Touchstart event for mobile
      span.addEventListener('touchstart', () => toggleExplanation(span));

      // Pointerdown event for more comprehensive support
      span.addEventListener('pointerdown', () => toggleExplanation(span));

      // Keydown event for accessibility (e.g., Enter or Space to toggle)
      span.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault(); // Prevent page scrolling for Space key
          toggleExplanation(span);
        }
      });
    });

    // Click event for the close button
    closeButton.addEventListener('click', closeExplanation);

    // Keydown event for the close button (e.g., Enter or Space to close)
    closeButton.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevent page scrolling for Space key
        closeExplanation();
      }
    });

    // Keydown event for closing with Escape key
    explanationDialog.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeExplanation();
      }
    });

    // Close the modal when clicking outside it
    explanationDialog.addEventListener('click', (event) => {
      const rect = explanationDialog.getBoundingClientRect();
      const isInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!isInside) {
        closeExplanation();
      }
    });
  } else {
    console.error('Required elements not found.');
  }
});
